import React from 'react';
import { routes } from 'constants/config';

const ConversationMetricsTableRow = ({
  conversationMetric,
  lessonIdString,
  groupId,
}) => {
  const {
    questionId,
    questionPosition,
    conversationTitle,
    conversationCompletions,
  } = conversationMetric;
  const title =
    conversationTitle || t('lesson_performance.no_question_subject');

  return (
    <tr>
      <td className="PerformanceTable-rowHead">{questionPosition}</td>
      <td className="text-wrap">{title}</td>
      <td className="PerformanceTable-shrink">
        <a
          href={routes.LESSON_OVERVIEW.QUESTION(
            lessonIdString,
            questionId,
            groupId,
          )}
          className="td-u"
        >
          <span className="u-nowrap">
            {t('lesson_performance.responses_count', {
              count: conversationCompletions,
            })}
          </span>
        </a>
      </td>
    </tr>
  );
};
export default ConversationMetricsTableRow;
